// Alphabet chosen to avoid visually ambiguous characters (0/O, 1/l/I) so admins
// can read the password aloud or copy from another window without errors.
const PASSWORD_ALPHABET = 'abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789!@#$%^&*';

export function generatePassword(length = 16): string {
  const bytes = new Uint32Array(length);
  crypto.getRandomValues(bytes);
  let out = '';
  for (let i = 0; i < length; i++) {
    out += PASSWORD_ALPHABET[bytes[i] % PASSWORD_ALPHABET.length];
  }
  return out;
}

export const customerCreateSchemaRules = {
  nameMin: 1,
  emailFormat: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  passwordMin: 12,
};
